/** @format */

import styled from "styled-components";

const Wrapper = styled.div`
  color: white;
  padding: 50px 0px;
  .commonTitle {
    font-style: italic;
  }
  .content {
    margin-bottom: 20px;
  }
  .visionImg {
    margin: 20px 0px;
  }
  .content p {
    margin-bottom: 40px;
  }
`;

export default Wrapper;
